import type { MvcLeadGrid } from "@repo/models";
import type { GridList, GridPagination } from "@repo/ui";
import type { SortBy } from "@repo/ui/grid/types";

import type { LeadsSetting } from "../models/leadsSetting";

import { BaseController } from "./baseController";

export interface LeadsFilter extends GridPagination {
	startDate: Date | undefined;
	endDate: Date | undefined;
	brands?: number[];
	channels?: number[];
	marketers?: number[];
	states?: number[];
	branches?: number[];
	repFirstName?: string;
	repLastName?: string;
	repLogin?: string;
	customerFirstName?: string;
	customerLastName?: string;
	converted?: boolean;
	sortBy?: SortBy;
	leadId?: number;
}

export const controller = "Leads";

export class LeadsController extends BaseController {
	static Get = BaseController.GetFn(controller);
	static async getSettings(leadId: number) {
		const params = { leadId };

		return await LeadsController.Get<LeadsSetting>("GetSettings", params);
	}

	static async getLeads(filters: LeadsFilter) {
		const params = {
			...filters,
		};

		return await LeadsController.Get<GridList<MvcLeadGrid>>("GetLeads", params);
	}
}
